var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 46,
    viewBox: "0 0 30 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/hospital"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 35.6973H28M21.75 10.6973H9.25C5.5 10.6973 4.25 12.9348 4.25 15.6973V35.6973H26.75V15.6973C26.75 12.9348 25.5 10.6973 21.75 10.6973Z",
    stroke: "#202020",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5008 15.6973V21.9473M12.3758 18.8223H18.6258M18.0758 26.9473H12.9133C12.2758 26.9473 11.7383 27.4723 11.7383 28.1223V35.6973H19.2383V28.1223C19.241 27.9683 19.2128 27.8153 19.1555 27.6724C19.0982 27.5294 19.0128 27.3994 18.9045 27.2899C18.7962 27.1804 18.6671 27.0937 18.5248 27.0349C18.3824 26.976 18.2298 26.9462 18.0758 26.9473Z",
    stroke: "#202020",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.d7783f5c7f335bf423ba9effe7cd031e.svg";
export { ForwardRef as ReactComponent };